
require(["nhs/views/CommunityDetail/show"]);
